
export enum ResourceType {
    Account = 0,
    Contact = 1,
    Deal = 2,
    EngineerJob = 3,
    EngineerJobBooking = 4,
    Package = 5,
    Peripheral = 6,
    Product = 7,
    ProductGroup = 8,
    Sim = 9,
    Site = 10,
    Unit = 11,
    Vehicle = 12,
    Ticket = 13,
    Stock = 14,
    Engineer = 15,
    SoftwareLog = 16,
    Driver = 17,
    Trailer = 18,
    VerilocationUser = 19,
    Announcement = 20,
    Plot = 21,
    User = 22,
    DriverDecisionSupport = 23,
    GeocodedAddress = 24,
    Geofence = 25,
    Group = 26,
    Journey = 27,
    Message = 28,
    OutboundQueue = 29,
    RfidData = 30,
    DigiDl = 31,
    AlertRecord = 32,
    ReportSchedule = 33,
    Log = 34,
    Test = 35,
    MaintenanceType = 36,
    StirlingJob = 37,
    DigiDlPacket = 38,
    EngineerCommission = 39
}
